import { useEffect, useMemo, useState } from 'react';
import React from 'react';
import { Button, Layout, Table } from 'tea-component';
import { useHistory, useIntl } from 'umi';
import SvgIcon from '@/pages/home/components/SvgIcon';
import useExcel from '../hooks/useExcel';
import CardCommon from '@op/components/CardCommon';
const { mergeable } = Table.addons;
const { Content } = Layout;
export default function TopicTrackingExcel({ location }: any) {
  const { readerExcel, tabValue, tableRecord, loading, error } = useExcel();
  const { formatMessage } = useIntl();

  const getClassName = (value: number) => {
    return '';
  };
  const getNumberColor = (value: string | number) => {
    const newValue = Number(value);
    if (!isNaN(newValue)) {
      return getClassName(newValue);
    }
    if (typeof value === 'string' && value.endsWith('%')) {
      let realValue = value.substring(0, value.length - 1);
      const info = Number(realValue);
      return isNaN(info) ? 'text' : getClassName(info);
    }

    return 'text';
  };

  const [tableColumns, record] = useMemo(() => {
    if (tabValue) {
      const { record, tableTitle } = tableRecord[tabValue];

      const columns = tableTitle
        .map((key) => {
          const recordItem = record[0] || {};
          const value = recordItem[key];
          const className = getNumberColor(value);
          const isShortText = typeof value === 'string' && value.length < 15;
          return {
            key,
            width: className === 'text' && !isShortText ? 350 : 150,
            className,
          };
        })
        .map(({ key, width, className }) => ({
          key: key,
          header: key,
          width,
          render: (item: any) => {
            const value = item[key];
            return <div className={className}>{value}</div>;
          },
        }));

      return [columns, record];
    }
    return [[], []];
  }, [tableRecord, tabValue]);

  const [url, setUrl] = useState('');

  useEffect(() => {
    const { excelPath } = location.query;
    if (excelPath) {
      const url = decodeURIComponent(excelPath);
      setUrl(url);
      readerExcel(url);
    }
  }, [location]);
  const history = useHistory();
  return (
    <Content>
      <Content.Header
        showBackButton
        onBackButtonClick={() => {
          history.push('/opinion/Summary/TopicTracking?tab=excel');
        }}
        title={formatMessage({ id: 'Topic Breakdown' })}
        operation={
          <Button onClick={() => window.open(url)} type="link">
            <SvgIcon type="download" />
          </Button>
        }
      ></Content.Header>
      <Content.Body full>
        <CardCommon
          loading={loading}
          loadingHeight={650}
          className="dbo-summary-excel-table"
          empty={tableColumns.length === 0}
          emptyHeight={650}
        >
          <Table
            records={record}
            recordKey="id"
            bordered="all"
            columns={tableColumns}
            verticalTop
            addons={[
              mergeable({
                rowSpan: (columnIndex, recordIndex, context) => {
                  const { column, record } = context;
                  return record['rowSpan']?.[column.key] || 0;
                },
              }),
            ]}
          />
        </CardCommon>
      </Content.Body>
    </Content>
  );
}
